import { render, staticRenderFns } from "./AddGroup.vue?vue&type=template&id=8ab6d8f0&scoped=true"
import script from "./AddGroup.vue?vue&type=script&lang=js"
export * from "./AddGroup.vue?vue&type=script&lang=js"
import style0 from "./AddGroup.vue?vue&type=style&index=0&id=8ab6d8f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab6d8f0",
  null
  
)

export default component.exports